import * as polyfills from '../polyfills';

async function polyfill() {
  const promises = Object.values(polyfills)
    .map(Polyfill => new Polyfill())
    .filter(x => x.execute)
    .map(x => x.polyfill());

  return Promise.all(promises);
}

export { polyfill };
